const PERMISSION_KEY= "notification:notification_snapshot";
const PAGE_URL = {
    NOTIFICATION_SNAPSHOT_PAGE: "/admin/notification/notification-snapshot"
}

export {PERMISSION_KEY, PAGE_URL}

